import {rules as v} from '../scripts/rules';
const fundliste = {
  "Fundnr"                        : v.isNum,
  "Schnittnr"                     : v.isNumManyWithoutDash,
  "Planumsnr"                     : v.isNumManywithDash,
  "Profilnr"                      : v.isNumManyWithoutDash,
  "Befundnr"                      : v.isNumManyWithoutDash,
  "Material"                      : v.MaterialThes,
  "Warenart/Bezeichnung/Objekttyp": v.isFreetext, // v.warenartThes,
  "Partie"                        : v.PartiThes,
  "Anzahl"                        : v.isNum,
  "Datierung"                     : v.DateThes,
  "Bemerkung"                     : v.isFreetext,
  "in Restaurierung"              : v.isJN,
  "Fotonr"                        : v.isNumManyWithoutDash,
  "Datum"                         : v.isDate,
  "BearbeiterIn"                  : v.isFreetextNotEmpty
}

export default fundliste;
